import { render, staticRenderFns } from "./EditBindStaff.vue?vue&type=template&id=b4e47e96&scoped=true&"
import script from "./EditBindStaff.vue?vue&type=script&lang=js&"
export * from "./EditBindStaff.vue?vue&type=script&lang=js&"
import style0 from "./EditBindStaff.vue?vue&type=style&index=0&id=b4e47e96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e47e96",
  null
  
)

export default component.exports